import { createSlice } from '@reduxjs/toolkit'
import { PlanningRecord } from '@leadgen/models/client'
import authActions from '../auth/actions'
import actions from './actions'

export interface PlanningRecordState {
  planningRecord: PlanningRecord | undefined
  error?: string
  status: 'initial' | 'idle' | 'loading' | 'loading-more' | 'failed'
}

export const initialState: PlanningRecordState = {
  planningRecord: undefined,
  status: 'initial',
}

export const planningRecordSlice = createSlice({
  name: 'planningRecord',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(authActions.loggedOut.type, () => {
        return initialState
      })
      .addCase(actions.loadPlanningRecord.pending, state => {
        state.status = 'loading'
      })
      .addCase(actions.loadPlanningRecord.fulfilled, (state, action) => {
        state.status = 'idle'
        state.planningRecord = action.payload.data
        state.error = undefined
      })
      .addCase(actions.loadPlanningRecord.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(actions.updatePlanningRecord, (state, action) => {
        state.planningRecord = action.payload
      })
  },
})

export default planningRecordSlice
